import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhotoFilm } from '@fortawesome/pro-duotone-svg-icons';
import { useTranslate } from '@tolgee/react';
import { useDispatch, useSelector } from 'react-redux';
import { lomavisCreatorRootState } from '../../../../pages/lomavisCreator';
import { addMediaLibraryFiles } from '../../../../redux/slices/lomavisCreator/lomavisCreator';

const MediaLibraryPopup = ({ platform }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const location_slug = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.lomavisCreatorConfig?.location?.slug
  );
  const mediaLibraryUrl = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.lomavisCreatorConfig?.media_library?.url
  );

  const [popupParams, setPopupParams] = useState({
    width: 1000,
    height: 600,
    left: (window.innerWidth - 1000) / 2,
    top: 100,
    openCropper: true,
    currentPlatform: platform,
    maxMediaFiles: 10,
    videoSelectAllowed: true,
    location_slug: location_slug
  });

  const openMediaLibrary = () => {
    const {
      width,
      height,
      left,
      top,
      openCropper,
      currentPlatform,
      maxMediaFiles,
      videoSelectAllowed,
      location_slug
    } = popupParams;

    const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,directories=no,copyhistory=no,width=${width},height=${height},left=${left},top=${top}`;
    const url = `${window.location.origin}${mediaLibraryUrl}?mode=popup&trigger=id_imageWrapperId&openCropper=${openCropper}&maxMediaFiles=${maxMediaFiles}&videoSelectAllowed=${videoSelectAllowed}`;

    const newWindow = window.open(url, 'mediaLibraryPopup', params);
    if (newWindow) {
      newWindow.focus();
      window.addEventListener(
        'LomavisMediaLibraryPopUpFileSelected',
        handleFileSelection
      );
    }
  };

  const handleFileSelection = (event) => {
    const mediaList = JSON.parse(event.detail?.data);

    console.log('media library file', mediaList);

    dispatch(
      addMediaLibraryFiles({
        platform: platform,
        files: mediaList
      })
    );
    window.removeEventListener(
      'LomavisMediaLibraryPopUpFileSelected',
      handleFileSelection
    );

    // TODO: Check if media is allowed and add to file list
    // TODO: If sync edit should be added, open also sync edit
  };

  return (
    <button
      className={'btn btn-white btn-sm pt-1 px-2'}
      onClick={openMediaLibrary}
      key={`popup_btn_${platform}`}
    >
      <span>
        <i className="fa-duotone fa-photo-film"></i>
      </span>
      <span className="text-muted fw-bolder">
        {t('lomavisCreator.openMedialibrary')}
      </span>
    </button>
  );
};

export default MediaLibraryPopup;
